(function () {
    function initStickyAtc(sectionElement) {
        if (!sectionElement || sectionElement.dataset.initialized === 'true') {
            return;
        }

        sectionElement.dataset.initialized = 'true';

        var variantInput = sectionElement.querySelector('[data-sticky-variant-id]');
        var priceElement = sectionElement.querySelector('[data-sticky-price]');
        var pixPriceElement = sectionElement.querySelector('[data-sticky-pix-price]');
        var installmentPriceElement = sectionElement.querySelector('[data-installments-price]');
        var variantTitleElement = sectionElement.querySelector('[data-sticky-variant-title]');
        var submitButton = sectionElement.querySelector('[data-sticky-submit]');
        var submitLabel = sectionElement.querySelector('[data-sticky-submit-label]');
        var heroElement = document.querySelector('[data-product-hero]');
        var buttonLabel = sectionElement.getAttribute('data-button-label') || 'COMPRAR';
        var soldOutLabel = sectionElement.getAttribute('data-sold-out-label') || 'Sem estoque';
        var defaultVariantLabel = sectionElement.getAttribute('data-default-variant-label') || 'Selecao padrao';
        var isCartDrawerOpen = false;

        function toggleVisibility() {
            if (!heroElement || window.innerWidth >= 990) {
                sectionElement.classList.remove('is-visible');
                return;
            }

            var heroRect = heroElement.getBoundingClientRect();
            var shouldShow = heroRect.bottom < window.innerHeight * 0.45 && !isCartDrawerOpen;

            sectionElement.classList.toggle('is-visible', shouldShow);
        }

        document.addEventListener('filadelfia:variant:change', function (event) {
            if (!event.detail || !event.detail.variant) {
                return;
            }

            var variant = event.detail.variant;

            if (variantInput) {
                variantInput.value = variant.id;
            }

            if (priceElement) {
                priceElement.textContent = variant.priceFormatted;
            }

            if (pixPriceElement) {
                pixPriceElement.innerHTML = 'Pague por pix';
            }

            if (installmentPriceElement && variant.installmentPriceFormatted) {
                installmentPriceElement.textContent = variant.installmentPriceFormatted;
            }

            if (variantTitleElement) {
                variantTitleElement.textContent = variant.title && variant.title !== 'Default Title'
                    ? variant.title
                    : defaultVariantLabel;
            }

            if (submitButton && submitLabel) {
                submitButton.disabled = !variant.available;
                submitLabel.textContent = variant.available ? buttonLabel : soldOutLabel;
            }
        });

        document.addEventListener('filadelfia:cart:toggle', function (event) {
            isCartDrawerOpen = Boolean(event.detail && event.detail.isOpen);
            toggleVisibility();
        });

        window.addEventListener('scroll', toggleVisibility, { passive: true });
        window.addEventListener('resize', toggleVisibility);

        toggleVisibility();
    }

    window.filadelfiaStickyAtc = {
        init: initStickyAtc
    };
})();
